<template>
<v-expansion-panel focusable :value="unprocessedPickRecords.length == 1 ? 0: -1">
    <v-expansion-panel-content v-for="(plant, i) in dataByPlant" :key="i">
        <template v-slot:actions>
            <v-icon color="primary">$vuetify.icons.expand</v-icon>
        </template>
        <template v-slot:header>
            <div>
                <span>{{ plant[0].PlantName }}</span>
            </div>
        </template>
        <v-layout row wrap class="pa-2">
            <v-flex v-for="(item, j) in dataByPlant[i]" :key="j" xs-12 sm-6 >
                <v-card color="blue-grey darken-2" dark>
                    <v-card-title>
                        <h3>{{item.DivisionName}}</h3>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text :class="{ 'pa-0': $vuetify.breakpoint.xs }">
                        <table class="unprocessed-table">
                            <tr>
                                <th>
                                </th>
                                <th class="contentTitle">
                                    Unprocessed
                                </th>
                                <th class="contentTitle">
                                    Problematic
                                </th>
                            </tr>
                            <tr>
                                <td>
                                    Today
                                </td>
                                <td class="contentValue">
                                    <v-btn icon small color="warning" @click="navigate(unprocessedUrl + item.PlantID)">{{ item.TodayUnprocessedTotal }}</v-btn>
                                    <span>{{ item.TodayUnprocessed}}</span>
                                </td>
                                <td class="contentValue">
                                    <v-btn icon small color="error" @click="navigate(problematicUrl + item.PlantID)">{{ item.TodayProblematicTotal }}</v-btn>
                                    <span>{{ item.TodayProblematic}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Yesterday
                                </td>
                                <td class="contentValue">
                                    <v-btn icon small color="warning" @click="navigate(unprocessedUrl + item.PlantID)">{{ item.YesterdayUnprocessedTotal }}</v-btn>
                                    <span>{{ item.YesterdayUnprocessed }}</span>
                                </td>
                                <td class="contentValue">
                                    <v-btn icon small color="error" @click="navigate(problematicUrl + item.PlantID)">{{ item.YesterdayProblematicTotal }}</v-btn>
                                    <span>{{ item.YesterdayProblematic }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Older
                                </td>
                                <td class="contentValue">
                                    <v-btn icon small color="warning" @click="navigate(unprocessedUrl + item.PlantID)">{{ item.OlderUnprocessedTotal }}</v-btn>
                                    <span>{{ item.OlderUnprocessed }}</span>
                                </td>
                                <td class="contentValue">
                                    <v-btn icon small color="error" @click="navigate(problematicUrl + item.PlantID)">{{ item.OlderProblematicTotal }}</v-btn>
                                    <span>{{ item.OlderProblematic }}</span>
                                </td>
                            </tr>
                        </table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-expansion-panel-content>
</v-expansion-panel>
</template>

<script>
export default {
    props: ['unprocessedPickRecords'],
    data() {
        return {}
    },
    computed: {
        unprocessedUrl() {
            return '/Modules/Plants/UnprocessedPickRecords.aspx?PlantID='
        },
        problematicUrl() {
            return '/Modules/Plants/ProblematicPickRecords.aspx?PlantID='
        },
        dataByPlant() {
            let l_grouped = this.unprocessedPickRecords.reduce(function (r, a) {
                r[a.PlantName] = r[a.PlantName] || [];
                r[a.PlantName].push(a);
                return r;
            }, Object.create(null));
            return l_grouped;
        }
    },
    methods: {
        navigate(url) {
            window.location.href = "/" + process.env.VUE_APP_OLD_HMS_ROOT + url
        }
    }
}
</script>

<style>
.unprocessed-table th, .unprocessed-table td {
    padding: 3px;
    text-align: left;
}
.unprocessed-table .contentTitle {
    text-align: center;
}
.unprocessed-table .contentValue {
    text-align: left;
}
</style>
